<template>
  <app-layout ref="layout">
    <page-layout>
      <template #header>
        <page-header :title="t('profile')"></page-header>
      </template>

      <template #content>
        <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
          <div>
            <update-profile-information-form
              :user="$page.props.user.data"
            ></update-profile-information-form>
            <ui-divider class="py-8"></ui-divider>
          </div>

          <div>
            <update-password-form />

            <ui-divider class="py-8"></ui-divider>
          </div>

          <logout-other-browser-sessions-form
            @showMessage="showMessage"
            :sessions="sessions"
          />
        </div>
      </template>
    </page-layout>
  </app-layout>
</template>

<script>
import PageHeader from "./../Shared/Organisms/PageHeader";
import AppLayout from "./../Layouts/AppLayout";
import PageLayout from "./../Layouts/PageLayout";
import DeleteUserForm from "./Profile/DeleteUserForm";
import JetSectionBorder from "./../Jetstream/SectionBorder";
import LogoutOtherBrowserSessionsForm from "./Profile/LogoutOtherBrowserSessionsForm";
import TwoFactorAuthenticationForm from "./Profile/TwoFactorAuthenticationForm";
import UpdatePasswordForm from "./Profile/UpdatePasswordForm";
import UpdateProfileInformationForm from "./Profile/UpdateProfileInformationForm";
import { useI18n } from "vue-i18n";

export default {
  emits: ["accountSwitched"],

  props: ["sessions"],

  setup() {
    const { t } = useI18n();
    return { t };
  },

  methods: {
    showMessage(style, message) {
      this.$refs.layout.showMessage(style, message);
    },
  },

  components: {
    PageLayout,
    PageHeader,
    AppLayout,
    DeleteUserForm,
    JetSectionBorder,
    LogoutOtherBrowserSessionsForm,
    TwoFactorAuthenticationForm,
    UpdatePasswordForm,
    UpdateProfileInformationForm,
  },
};
</script>


<i18n>
{
  "es": {
    "profile": "Perfil"
  }
}
</i18n>
